export const messages = {
  en: {
    couponManage: {
      queryCondition: 'Query Conditions',
      selectCouponName: 'Please enter coupon name',
      selectCouponType: 'Please select coupon type',
      selectStatus: 'Please select status',
      query: 'Query',
      coupons: 'Coupons',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      give: 'Give',
      couponCode: 'Coupon Code',
      couponName: 'Coupon Name',
      couponType: 'Coupon Type',
      fullReduction: 'Full Reduction',
      discount: 'Discount',
      discountInfo: 'Discount Info',
      reduce: 'Reduce',
      off: 'Off',
      minAmount: 'Min Amount',
      totalQuantity: 'Total Quantity',
      status: 'Status',
      operation: 'Operation',
      inUse: 'In Use',
      invalid: 'Invalid',
      unused: 'Unused',
      used: 'Used',
      expired: 'Expired',
      confirmOperation: 'Please confirm your operation!',
      confirmDeleteCoupon: 'Confirm to delete coupon',
      confirmDelete: 'Confirm Delete!',
      addCoupon: 'Add Coupon',
      editCoupon: 'Edit Coupon',
      deleteCoupon: 'Delete Coupon',
      giveCoupon: 'Give Coupon',
      couponCodeRequired: 'Required, please enter coupon code',
      couponNameRequired: 'Required, please enter coupon name',
      couponTypeRequired: 'Required, please select coupon type',
      discountAmount: 'Discount Amount',
      discountAmountRequired: 'Required, please enter discount amount',
      discountPercent: 'Discount Percent',
      discountPercentRequired: 'Required, please enter discount percent',
      minAmountPlaceholder: 'Please enter minimum amount',
      maxDiscount: 'Max Discount',
      maxDiscountPlaceholder: 'Please enter max discount',
      description: 'Description',
      descriptionPlaceholder: 'Please enter description',
      totalQuantityRequired: 'Required, please enter total quantity',
      limitPerUser: 'Limit Per User',
      limitPerUserPlaceholder: 'Please enter limit per user',
      issueType: 'Issue Type',
      issueTypeRequired: 'Required, please select issue type',
      userReceive: 'User Receive',
      shopGive: 'Shop Give',
      validDays: 'Valid Days',
      validDaysPlaceholder: 'Please enter valid days',
      startTime: 'Start Time',
      startTimePlaceholder: 'Please select start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Please select end time',
      phoneNumber: 'Phone Number',
      phoneNumberRequired: 'Required, please enter phone number',
      phoneNumberPlaceholder: 'Please enter phone number',
      userNotExists: 'User does not exist',
      giveSuccess: 'Give coupon successfully',
      userName: 'User Name',
      userCoupons: 'User Coupons',
      validTime: 'Valid Time',
      receiveTime: 'Receive Time',
      giveLogs: 'Give Logs',
      giveTime: 'Give Time',
      giveUser: 'Give User',
      receiveLogs: 'Receive Logs',
      receiveType: 'Receive Type',
      useLogs: 'Use Logs',
      orderId: 'Order ID',
      useTime: 'Use Time',
      selectCoupon: 'Select Coupon',
      selectCouponRequired: 'Required, please select coupon',
      id: 'ID'
    },
    staffCollectedProduct: {
      queryCondition: 'Query Conditions',
      all: 'All',
      collectedProducts: 'Collected Products',
      addTitle: 'Add Collected Product',
      confirmDelete: 'Confirm to delete collected product?',
      cpId: 'ID',
      coverPhoto: 'Cover Photo',
      prodName: 'Product Name',
      specName: 'Specification Name',
      barCode: 'Bar Code',
      collectType: 'Collect Type',
      sort: 'Sort',
      createTime: 'Create Time',
      inputProdName: 'Please enter product name',
      inputBarCode: 'Please enter bar code',
      common: 'Common',
      noCode: 'No Code',
      weigh: 'Weigh',
      selectProductFirst: 'Please select product first'
    },
    platformCoupon: {
      queryCondition: 'Query Conditions',
      selectCouponName: 'Please enter coupon name',
      selectCouponCode: 'Please enter coupon code',
      selectCouponType: 'Please select coupon type',
      query: 'Query',
      all: 'All',
      onShelfStatus: 'On Shelf',
      offShelfStatus: 'Off Shelf',
      coupons: 'Platform Coupons',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      onShelf: 'On Shelf',
      offShelf: 'Off Shelf',
      couponCode: 'Coupon Code',
      couponName: 'Coupon Name',
      couponType: 'Coupon Type',
      fullReduction: 'Full Reduction',
      discount: 'Discount',
      discountInfo: 'Discount Info',
      reduce: 'Reduce',
      off: 'Off',
      minAmount: 'Min Amount',
      totalQuantity: 'Total Quantity',
      receivedCount: 'Received',
      usedCount: 'Used',
      scope: 'Scope',
      allScope: 'All Platform',
      status: 'Status',
      operation: 'Operation',
      confirmOperation: 'Please confirm your operation!',
      confirmDeleteCoupon: 'Confirm to delete the coupon',
      confirmOnShelf: 'Confirm to on-shelf the coupon?',
      confirmOffShelf: 'Confirm to off-shelf the coupon?',
      confirmDelete: 'Confirm',
      addCoupon: 'Add Platform Coupon',
      editCoupon: 'Edit Platform Coupon',
      deleteCoupon: 'Delete Platform Coupon',
      selectStatus: 'Please select status',
      inUse: 'On Shelf',
      invalid: 'Off Shelf',
      couponCodeRequired: 'Required, please enter coupon code',
      couponNameRequired: 'Required, please enter coupon name',
      couponTypeRequired: 'Required, please select coupon type',
      discountAmount: 'Discount Amount',
      discountAmountRequired: 'Required, please enter discount amount',
      discountPercent: 'Discount Percent',
      discountPercentRequired: 'Required, please enter discount percent',
      minAmountPlaceholder: 'Please enter minimum amount',
      maxDiscount: 'Max Discount',
      maxDiscountPlaceholder: 'Please enter max discount',
      description: 'Description',
      descriptionPlaceholder: 'Please enter description',
      totalQuantityRequired: 'Required, please enter total quantity',
      limitPerUser: 'Limit Per User',
      limitPerUserPlaceholder: 'Please enter limit per user',
      validDays: 'Valid Days',
      validDaysPlaceholder: 'Please enter valid days',
      startTime: 'Start Time',
      startTimePlaceholder: 'Please select start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Please select end time',
      operationFail: 'Operation failed, please try again later',
      userName: 'User Name',
      phoneNumber: 'Phone Number',
      receiveLogs: 'Receive Logs',
      receiveTime: 'Receive Time',
      receiveType: 'Receive Type',
      userReceive: 'User Receive',
      shopGive: 'Platform Give',
      useLogs: 'Use Logs',
      orderId: 'Order ID',
      useTime: 'Use Time',
      id: 'ID'
    }
  },
  zh: {
    couponManage: {
      queryCondition: '查询条件',
      selectCouponName: '请输入优惠券名称',
      selectCouponType: '请选择优惠类型',
      selectStatus: '请选择状态',
      query: '查询',
      coupons: '优惠券',
      add: '添加',
      edit: '修改',
      delete: '删除',
      give: '赠送',
      couponCode: '优惠券编码',
      couponName: '优惠券名称',
      couponType: '优惠类型',
      fullReduction: '满减',
      discount: '折扣',
      discountInfo: '优惠信息',
      reduce: '减',
      off: '折',
      minAmount: '最低消费',
      totalQuantity: '发行总量',
      status: '状态',
      operation: '操作',
      inUse: '在用',
      invalid: '失效',
      unused: '未使用',
      used: '已使用',
      expired: '已过期',
      confirmOperation: '请确认您的操作!',
      confirmDeleteCoupon: '确定删除优惠券',
      confirmDelete: '确认删除!',
      addCoupon: '添加优惠券',
      editCoupon: '修改优惠券',
      deleteCoupon: '删除优惠券',
      giveCoupon: '赠送优惠券',
      couponCodeRequired: '必填，请填写优惠券编码',
      couponNameRequired: '必填，请填写优惠券名称',
      couponTypeRequired: '必填，请选择优惠类型',
      discountAmount: '优惠金额',
      discountAmountRequired: '必填，请填写优惠金额',
      discountPercent: '折扣比例',
      discountPercentRequired: '必填，请填写折扣比例',
      minAmountPlaceholder: '请输入最低消费金额',
      maxDiscount: '最大优惠金额',
      maxDiscountPlaceholder: '请输入最大优惠金额',
      description: '描述',
      descriptionPlaceholder: '请输入描述',
      totalQuantityRequired: '必填，请填写发行总量',
      limitPerUser: '每人限领',
      limitPerUserPlaceholder: '请输入每人限领数量',
      issueType: '发放方式',
      issueTypeRequired: '必填，请选择发放方式',
      userReceive: '用户领取',
      shopGive: '商家赠送',
      validDays: '有效天数',
      validDaysPlaceholder: '请输入有效天数',
      startTime: '开始时间',
      startTimePlaceholder: '请选择开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '请选择结束时间',
      phoneNumber: '手机号',
      phoneNumberRequired: '必填，请输入手机号',
      phoneNumberPlaceholder: '请输入手机号',
      userNotExists: '用户不存在',
      giveSuccess: '赠送成功',
      userName: '用户名称',
      userCoupons: '用户优惠券',
      validTime: '有效期',
      receiveTime: '领取时间',
      giveLogs: '赠送记录',
      giveTime: '赠送时间',
      giveUser: '赠送人',
      receiveLogs: '领取记录',
      receiveType: '领取方式',
      useLogs: '使用记录',
      orderId: '订单号',
      useTime: '使用时间',
      selectCoupon: '选择优惠券',
      selectCouponRequired: '必填，请选择优惠券',
      id: '编号'
    },
    staffCollectedProduct: {
      queryCondition: '查询条件',
      all: '全部',
      collectedProducts: '收藏商品',
      addTitle: '添加收藏商品',
      confirmDelete: '确定删除收藏商品?',
      cpId: '编号',
      coverPhoto: '商品图标',
      prodName: '商品名称',
      specName: '规格名称',
      barCode: '条码',
      collectType: '收藏类别',
      sort: '排序',
      createTime: '创建时间',
      inputProdName: '请输入商品名称',
      inputBarCode: '请输入条码',
      common: '常用',
      noCode: '无码',
      weigh: '散称',
      selectProductFirst: '请先选择商品'
    },
    platformCoupon: {
      queryCondition: '查询条件',
      selectCouponName: '请输入优惠券名称',
      selectCouponCode: '请输入优惠券编码',
      selectCouponType: '请选择优惠类型',
      query: '查询',
      all: '全部',
      onShelfStatus: '上架中',
      offShelfStatus: '已下架',
      coupons: '平台优惠券',
      add: '添加',
      edit: '修改',
      delete: '删除',
      onShelf: '上架',
      offShelf: '下架',
      couponCode: '优惠券编码',
      couponName: '优惠券名称',
      couponType: '优惠类型',
      fullReduction: '满减',
      discount: '折扣',
      discountInfo: '优惠信息',
      reduce: '减',
      off: '折',
      minAmount: '最低消费',
      totalQuantity: '发行总量',
      receivedCount: '已领取',
      usedCount: '已使用',
      scope: '适用范围',
      allScope: '全场通用',
      status: '状态',
      operation: '操作',
      confirmOperation: '请确认您的操作!',
      confirmDeleteCoupon: '确认删除该优惠券',
      confirmOnShelf: '确认上架该优惠券?',
      confirmOffShelf: '确认下架该优惠券?',
      confirmDelete: '确认',
      addCoupon: '添加平台优惠券',
      editCoupon: '修改平台优惠券',
      deleteCoupon: '删除平台优惠券',
      selectStatus: '请选择状态',
      inUse: '上架中',
      invalid: '已下架',
      couponCodeRequired: '必填，请填写优惠券编码',
      couponNameRequired: '必填，请填写优惠券名称',
      couponTypeRequired: '必填，请选择优惠类型',
      discountAmount: '优惠金额',
      discountAmountRequired: '必填，请填写优惠金额',
      discountPercent: '折扣比例',
      discountPercentRequired: '必填，请填写折扣比例',
      minAmountPlaceholder: '请输入最低消费金额',
      maxDiscount: '最大优惠金额',
      maxDiscountPlaceholder: '请输入最大优惠金额',
      description: '描述',
      descriptionPlaceholder: '请输入描述',
      totalQuantityRequired: '必填，请填写发行总量',
      limitPerUser: '每人限领',
      limitPerUserPlaceholder: '请输入每人限领数量',
      validDays: '有效天数',
      validDaysPlaceholder: '请输入有效天数',
      startTime: '开始时间',
      startTimePlaceholder: '请选择开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '请选择结束时间',
      operationFail: '操作失败，请稍后重试',
      userName: '用户名称',
      phoneNumber: '手机号',
      receiveLogs: '领取记录',
      receiveTime: '领取时间',
      receiveType: '领取方式',
      userReceive: '用户领取',
      shopGive: '平台赠送',
      useLogs: '使用记录',
      orderId: '订单号',
      useTime: '使用时间',
      id: '编号'
    }
  }
}

